import { RefiAdobeTarget } from '../../adobe-target/adobe-target.js';
import '../../utils/load-script.js';
import '../../utils/wait-for-dom.js';
import '../../utils/refi-mfe-uuid.js';
import '../../utils/track-analytics-event.js';

class RefiMbox extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    this.mbox = this.getAttribute('mbox');
    this.replace = this.hasAttribute('replace');
    this.shadowRoot.innerHTML = this.replace ? `<slot></slot>` : `<div id="${this.mbox}Mbox"></div><slot></slot>`;
    this.params = {
      env: window.location.hostname === 'autorefi.capitalone.com' || window.location.hostname === 'coaf-refi-web-ui.capitalone.com' ? 'prod' : 'qa',
    };
    this.style.display = 'block';
    this.style.transition = 'opacity 0.5s ease-in-out';
    this.style.opacity = '0';
    this.generateParams();
    this.applyTest();
  }

  makeVisible() {
    this.style.opacity = '1';
  }

  async replaceDataAttributes(res) {
    Object.keys(this.dataset).forEach(data => {
      const dataValue = this.dataset[data];
      const elem = this.querySelector(`[${data}]`);
      if (elem) {
        elem.setAttribute(data, dataValue);
      }
    });
    return res;
  }

  applyTest() {
    const mboxOpts = {
      mbox: `refi.${this.mbox}`,
      params: this.params,
      selector: this.replace ? this : this.shadowRoot.querySelector(`#${this.mbox}Mbox`),
    };
    RefiAdobeTarget.getOffer(mboxOpts)
      .then(RefiAdobeTarget.applyOffer.bind(RefiAdobeTarget))
      .then(this.replaceDataAttributes.bind(this))
      .then(this.cloneScripts.bind(this))
      .then(this.makeVisible.bind(this))
      .catch(this.makeVisible.bind(this));
  }

  generateParams() {
    const params = Object.values(this.attributes).filter(attr => attr.name.startsWith('param-'));
    params.forEach(attr => {
      this.params[attr.name.replace('param-', '')] = attr.value;
    });
  }

  async cloneScripts(res) {
    const scripts = this.replace ? this.querySelectorAll('script') : this.shadowRoot.querySelectorAll('script');
    scripts.forEach(script => {
      const newScript = document.createElement('script');
      newScript.innerHTML = script.innerHTML;
      document.body.appendChild(newScript);
    });
    return res;
  }
}

export { RefiMbox };
